import { StackProps, Stack, Typography, Box } from '@mui/material'
import { Theme, useTheme, styled } from '@mui/material/styles'
import { Background1 } from 'components/backgrounds/Background1'
import { MainLogo } from 'components/images'
import { useCurrentUser, useSignIn } from 'hooks'
import { KGoogleLoginButton } from 'components/core/KGoogleLoginButton'
import { Link as RouterLink } from 'react-router-dom'
import { TypeRoute } from 'core/TypeRoute'

const FormContainer = styled(Stack)<StackProps>((props) => {
  const theme: Theme = props.theme as unknown as Theme
  return {
    margin: 'auto',
    marginTop: 200,
    width: 400,
    minWidth: 320,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  }
})

export const HomePage = () => {
  const theme = useTheme()
  const signIn = useSignIn()
  const { currentUser } = useCurrentUser()

  const signInWithGoogle = () => {
    signIn('Google')
  }

  return (
    <Background1
      sx={{
        height: `calc(100% - ${theme.spacing(8)})`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowY: 'auto',
        paddingY: 4,
      }}
    >
      <FormContainer>
        <MainLogo width="100%" />
        {!currentUser && <KGoogleLoginButton onClick={signInWithGoogle} />}
        {currentUser && (
          <Typography variant="h1">
            Welcome {currentUser.firstName} {currentUser.lastName}
          </Typography>
        )}
      </FormContainer>

      <Box sx={{ marginTop: 'auto', textAlign: 'center', py: 2 }}>
        <Typography
          variant="body2"
          component={RouterLink}
          to={TypeRoute.PrivacyPolicy}
          sx={{
            color: theme.palette.primary.main,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          Privacy Policy
        </Typography>
      </Box>
    </Background1>
  )
}
